import { Divider } from '@components'
import { Spinner } from '@heroui/react'
import PropTypes from 'prop-types'

const ProcessingEmailsLoader = ({ queuedCount }) => {
  const title = queuedCount > 1 
    ? `${queuedCount} emails pending`
    : `${queuedCount} email pending`

  return (
    <div>
      <div className='flex items-center gap-3 p-4 mb-4 rounded-lg bg-content2'>
        <Spinner /> 
        
        <div>
          <p className='font-semibold'>{title}</p>
          <p className='text-content2-foreground'>Stats will automatically refresh every minute.</p>
        </div>
      </div>
      
      <Divider className='mb-4' />
    </div>
  )
}

ProcessingEmailsLoader.propTypes = {
  queuedCount: PropTypes.number.isRequired,
}

export default ProcessingEmailsLoader